export default function log(action, data = {}) {
	const out = {
		s: "seno",
		u: location.href,
		a: action,
		d: data,
	};

	const params: Array<string> = [];

	for (const key in out) {
		if (Object.prototype.hasOwnProperty.call(out, key)) {
			let value = out[key];

			if (key === "d") {
				value = JSON.stringify(value);
			}
			params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
		}
	}

	new Image().src = `//jslog.post.cz/hit/?${params.join("&")}`;
}
